export default __webpack_public_path__ + "static/ArminGrotesk-Regular-72d36d4ee0e64b226e40df9c2aeb47ab.woff";